import { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      story: "Notre histoire",
      team: "Membres Fondateurs",
      establishments: "Etablissements",
      press: "Presse",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Le Haut-Bréda · Massif de Belledonne · Isère",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["L'âme de la vallée,", "servie à table."],
      sub: "Fait vivre la vallée du Haut-Bréda, été comme hiver.",
      cta2: "Nous contacter",
      scroll: "Défiler",
    },
    story: {
      eyebrow: "Notre histoire",
      title: "Une maison née au fil du Bréda",
      p1: "Au pied des sommets de Belledonne, là où le Bréda creuse sa vallée entre forêts d'épicéas et alpages, quatre associés ont voulu créer bien plus qu'un restaurant : une maison ouverte à toute la vallée du Haut-Bréda.",
      p2: "Immatriculée en 2026 au greffe de Grenoble, Rest'Ô Bréda SARL réunit restauration, snack, pizzeria, bar, dépôt de pain et épicerie de montagne. Un lieu de vie et de rencontre, pensé pour les habitants de la vallée comme pour les amoureux des 7 Laux, en toute saison.",
      quote: "« Nous avons voulu un lieu simple et vrai, où la montagne se goûte dans l'assiette. »",
      quoteAuthor: "Jean-Philippe Vacher, Gérant",
      stats: [
        { value: "2026", label: "Année de création" },
        { value: "1 000 €", label: "Capital social" },
        { value: "4", label: "Associés fondateurs" },
        { value: "1", label: "Employé" },
        { value: "38580", label: "Le Haut-Bréda, Isère" },
      ],
    },
    team: {
      eyebrow: "Membres fondateurs",
      title: "Quatre visages, une seule maison",
      sub: "Jean-Philippe, Michel, Marie-Hélène et Tetiana — les quatre associés qui portent Rest'Ô Bréda au quotidien.",
      members: [
        { id: "jean-philippe", name: "Jean-Philippe", role: "Gérant" },
        { id: "michel", name: "Michel", role: "Associé" },
        { id: "marie-helene", name: "Marie-Hélène", role: "Associée" },
        { id: "tetiana", name: "Tetiana", role: "Associée" },
      ],
    },
    establishments: {
      eyebrow: "Établissements",
      line: "Une surprise bientôt arrivera",
      sub: "À suivre",
      date: "Ouverture le 15 novembre 2026 au plus tard",
      units: { days: "Jours", hours: "Heures", minutes: "Minutes", seconds: "Secondes" },
    },
    press: {
      eyebrow: "Presse",
      line: "En construction",
      sub: "Cet espace sera bientôt disponible.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Venez nous rencontrer",
      text: "Une question, un événement, une envie de découvrir la maison ? Écrivez-nous — nous répondons vite.",
      emailLabel: "Écrivez-nous",
      phoneLabel: "Téléphone",
      addressLabel: "Adresse",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Vallée du Haut-Bréda · Les 7 Laux · Belledonne",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Restaurant · Pizzeria · Bar · Épicerie de montagne",
      legal: "Rest'Ô Bréda SARL au capital de 1 000 € — SIREN 109 246 421 — RCS Grenoble — TVA FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Tous droits réservés.",
    },
  },
  en: {
    nav: {
      home: "Home",
      story: "Our story",
      team: "Founding Members",
      establishments: "Establishments",
      press: "Press",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Le Haut-Bréda · Belledonne range · French Alps",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["The soul of the valley,", "served at the table."],
      sub: "Bringing the Haut-Bréda valley to life, summer and winter alike.",
      cta2: "Get in touch",
      scroll: "Scroll",
    },
    story: {
      eyebrow: "Our story",
      title: "A house born on the banks of the Bréda",
      p1: "At the foot of the Belledonne peaks, where the Bréda river carves its valley between spruce forests and alpine pastures, four partners set out to create far more than a restaurant: a house open to the whole Haut-Bréda valley.",
      p2: "Registered in 2026 with the Grenoble trade registry, Rest'Ô Bréda SARL brings together a restaurant, snack bar, pizzeria, bar, bread depot and mountain grocery. A place to live and meet — for valley locals and Les 7 Laux lovers alike, in every season.",
      quote: "\"We wanted a simple, honest place, where the mountains can be tasted on the plate.\"",
      quoteAuthor: "Jean-Philippe Vacher, Managing Partner",
      stats: [
        { value: "2026", label: "Year founded" },
        { value: "€1,000", label: "Share capital" },
        { value: "4", label: "Founding partners" },
        { value: "1", label: "Employee" },
        { value: "38580", label: "Le Haut-Bréda, Isère" },
      ],
    },
    team: {
      eyebrow: "Founding members",
      title: "Four faces, one house",
      sub: "Jean-Philippe, Michel, Marie-Hélène and Tetiana — the four partners who bring Rest'Ô Bréda to life every day.",
      members: [
        { id: "jean-philippe", name: "Jean-Philippe", role: "Managing Partner" },
        { id: "michel", name: "Michel", role: "Partner" },
        { id: "marie-helene", name: "Marie-Hélène", role: "Partner" },
        { id: "tetiana", name: "Tetiana", role: "Partner" },
      ],
    },
    establishments: {
      eyebrow: "Establishments",
      line: "A surprise is coming soon",
      sub: "Stay tuned",
      date: "Opening by November 15, 2026 at the latest",
      units: { days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds" },
    },
    press: {
      eyebrow: "Press",
      line: "Under construction",
      sub: "This space will be available soon.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Come and meet us",
      text: "A question, an event, or simply curious about the house? Write to us — we reply quickly.",
      emailLabel: "Write to us",
      phoneLabel: "Phone",
      addressLabel: "Address",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Haut-Bréda valley · Les 7 Laux · Belledonne",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Restaurant · Pizzeria · Bar · Mountain grocery",
      legal: "Rest'Ô Bréda SARL with a share capital of €1,000 — SIREN 109 246 421 — RCS Grenoble — VAT FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. All rights reserved.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      story: "Nuestra historia",
      team: "Miembros Fundadores",
      establishments: "Establecimientos",
      press: "Prensa",
      contact: "Contacto",
    },
    hero: {
      eyebrow: "Le Haut-Bréda · Cordillera de Belledonne · Alpes franceses",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["El alma del valle,", "servida a la mesa."],
      sub: "Hace vivir el valle de Haut-Bréda, en verano como en invierno.",
      cta2: "Contáctenos",
      scroll: "Desplazar",
    },
    story: {
      eyebrow: "Nuestra historia",
      title: "Una casa nacida a orillas del Bréda",
      p1: "Al pie de las cumbres de Belledonne, donde el Bréda labra su valle entre bosques de abetos y pastos alpinos, cuatro socios quisieron crear mucho más que un restaurante: una casa abierta a todo el valle de Haut-Bréda.",
      p2: "Inscrita en 2026 en el registro mercantil de Grenoble, Rest'Ô Bréda SARL reúne restaurante, snack, pizzería, bar, depósito de pan y tienda de montaña. Un lugar de vida y encuentro, pensado tanto para los habitantes del valle como para los amantes de Les 7 Laux, en cualquier estación.",
      quote: "« Quisimos un lugar sencillo y auténtico, donde la montaña se saborea en el plato. »",
      quoteAuthor: "Jean-Philippe Vacher, Gerente",
      stats: [
        { value: "2026", label: "Año de fundación" },
        { value: "1 000 €", label: "Capital social" },
        { value: "4", label: "Socios fundadores" },
        { value: "1", label: "Empleado" },
        { value: "38580", label: "Le Haut-Bréda, Isère" },
      ],
    },
    team: {
      eyebrow: "Miembros fundadores",
      title: "Cuatro rostros, una sola casa",
      sub: "Jean-Philippe, Michel, Marie-Hélène y Tetiana — los cuatro socios que hacen vivir Rest'Ô Bréda cada día.",
      members: [
        { id: "jean-philippe", name: "Jean-Philippe", role: "Gerente" },
        { id: "michel", name: "Michel", role: "Socio" },
        { id: "marie-helene", name: "Marie-Hélène", role: "Socia" },
        { id: "tetiana", name: "Tetiana", role: "Socia" },
      ],
    },
    establishments: {
      eyebrow: "Establecimientos",
      line: "Una sorpresa llegará pronto",
      sub: "Próximamente",
      date: "Apertura a más tardar el 15 de noviembre de 2026",
      units: { days: "Días", hours: "Horas", minutes: "Minutos", seconds: "Segundos" },
    },
    press: {
      eyebrow: "Prensa",
      line: "En construcción",
      sub: "Este espacio estará disponible pronto.",
    },
    contact: {
      eyebrow: "Contacto",
      title: "Venga a conocernos",
      text: "¿Una pregunta, un evento o ganas de descubrir la casa? Escríbanos: respondemos rápido.",
      emailLabel: "Escríbanos",
      phoneLabel: "Teléfono",
      addressLabel: "Dirección",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Valle de Haut-Bréda · Les 7 Laux · Belledonne",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Restaurante · Pizzería · Bar · Tienda de montaña",
      legal: "Rest'Ô Bréda SARL con un capital social de 1 000 € — SIREN 109 246 421 — RCS Grenoble — IVA FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Todos los derechos reservados.",
    },
  },
  de: {
    nav: {
      home: "Start",
      story: "Unsere Geschichte",
      team: "Gründungsmitglieder",
      establishments: "Betriebe",
      press: "Presse",
      contact: "Kontakt",
    },
    hero: {
      eyebrow: "Le Haut-Bréda · Belledonne-Massiv · Französische Alpen",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["Die Seele des Tals,", "auf den Tisch gebracht."],
      sub: "Belebt das Haut-Bréda-Tal, im Sommer wie im Winter.",
      cta2: "Kontakt",
      scroll: "Scrollen",
    },
    story: {
      eyebrow: "Unsere Geschichte",
      title: "Ein Haus, geboren am Lauf der Bréda",
      p1: "Am Fuße der Belledonne-Gipfel, wo sich die Bréda ihr Tal zwischen Fichtenwäldern und Almen gräbt, wollten vier Gesellschafter weit mehr als ein Restaurant schaffen: ein Haus, das dem gesamten Haut-Bréda-Tal offensteht.",
      p2: "2026 im Handelsregister von Grenoble eingetragen, vereint die Rest'Ô Bréda SARL Restaurant, Snack, Pizzeria, Bar, Brotdepot und Bergladen. Ein Ort des Lebens und der Begegnung — für die Talbewohner ebenso wie für die Liebhaber von Les 7 Laux, zu jeder Jahreszeit.",
      quote: "„Wir wollten einen einfachen, ehrlichen Ort, an dem man die Berge auf dem Teller schmeckt.“",
      quoteAuthor: "Jean-Philippe Vacher, Geschäftsführer",
      stats: [
        { value: "2026", label: "Gründungsjahr" },
        { value: "1 000 €", label: "Stammkapital" },
        { value: "4", label: "Gründungspartner" },
        { value: "1", label: "Mitarbeiter" },
        { value: "38580", label: "Le Haut-Bréda, Isère" },
      ],
    },
    team: {
      eyebrow: "Gründungsmitglieder",
      title: "Vier Gesichter, ein Haus",
      sub: "Jean-Philippe, Michel, Marie-Hélène und Tetiana — die vier Gesellschafter, die Rest'Ô Bréda jeden Tag tragen.",
      members: [
        { id: "jean-philippe", name: "Jean-Philippe", role: "Geschäftsführer" },
        { id: "michel", name: "Michel", role: "Gesellschafter" },
        { id: "marie-helene", name: "Marie-Hélène", role: "Gesellschafterin" },
        { id: "tetiana", name: "Tetiana", role: "Gesellschafterin" },
      ],
    },
    establishments: {
      eyebrow: "Betriebe",
      line: "Eine Überraschung kommt bald",
      sub: "Bleiben Sie dran",
      date: "Eröffnung spätestens am 15. November 2026",
      units: { days: "Tage", hours: "Stunden", minutes: "Minuten", seconds: "Sekunden" },
    },
    press: {
      eyebrow: "Presse",
      line: "Im Aufbau",
      sub: "Dieser Bereich ist bald verfügbar.",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Besuchen Sie uns",
      text: "Eine Frage, eine Veranstaltung oder Lust, das Haus kennenzulernen? Schreiben Sie uns — wir antworten schnell.",
      emailLabel: "Schreiben Sie uns",
      phoneLabel: "Telefon",
      addressLabel: "Adresse",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Haut-Bréda-Tal · Les 7 Laux · Belledonne",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Restaurant · Pizzeria · Bar · Bergladen",
      legal: "Rest'Ô Bréda SARL mit einem Stammkapital von 1 000 € — SIREN 109 246 421 — RCS Grenoble — USt-IdNr. FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Alle Rechte vorbehalten.",
    },
  },
  it: {
    nav: {
      home: "Home",
      story: "La nostra storia",
      team: "Membri Fondatori",
      establishments: "Stabilimenti",
      press: "Stampa",
      contact: "Contatti",
    },
    hero: {
      eyebrow: "Le Haut-Bréda · Massiccio di Belledonne · Alpi francesi",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["L'anima della valle,", "servita a tavola."],
      sub: "Fa vivere la valle di Haut-Bréda, d'estate come d'inverno.",
      cta2: "Contattaci",
      scroll: "Scorri",
    },
    story: {
      eyebrow: "La nostra storia",
      title: "Una casa nata lungo il Bréda",
      p1: "Ai piedi delle vette del Belledonne, dove il Bréda scava la sua valle tra foreste di abeti e alpeggi, quattro soci hanno voluto creare molto più di un ristorante: una casa aperta a tutta la valle di Haut-Bréda.",
      p2: "Registrata nel 2026 presso il tribunale di Grenoble, Rest'Ô Bréda SARL riunisce ristorante, snack, pizzeria, bar, deposito di pane e negozio di montagna. Un luogo di vita e di incontro, pensato per gli abitanti della valle come per gli amanti di Les 7 Laux, in ogni stagione.",
      quote: "« Volevamo un luogo semplice e autentico, dove la montagna si assapora nel piatto. »",
      quoteAuthor: "Jean-Philippe Vacher, Amministratore",
      stats: [
        { value: "2026", label: "Anno di fondazione" },
        { value: "1 000 €", label: "Capitale sociale" },
        { value: "4", label: "Soci fondatori" },
        { value: "1", label: "Dipendente" },
        { value: "38580", label: "Le Haut-Bréda, Isère" },
      ],
    },
    team: {
      eyebrow: "Membri fondatori",
      title: "Quattro volti, una sola casa",
      sub: "Jean-Philippe, Michel, Marie-Hélène e Tetiana — i quattro soci che portano avanti Rest'Ô Bréda ogni giorno.",
      members: [
        { id: "jean-philippe", name: "Jean-Philippe", role: "Amministratore" },
        { id: "michel", name: "Michel", role: "Socio" },
        { id: "marie-helene", name: "Marie-Hélène", role: "Socia" },
        { id: "tetiana", name: "Tetiana", role: "Socia" },
      ],
    },
    establishments: {
      eyebrow: "Stabilimenti",
      line: "Una sorpresa arriverà presto",
      sub: "Restate sintonizzati",
      date: "Apertura al più tardi il 15 novembre 2026",
      units: { days: "Giorni", hours: "Ore", minutes: "Minuti", seconds: "Secondi" },
    },
    press: {
      eyebrow: "Stampa",
      line: "In costruzione",
      sub: "Questo spazio sarà presto disponibile.",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Venite a trovarci",
      text: "Una domanda, un evento o voglia di scoprire la casa? Scriveteci: rispondiamo in fretta.",
      emailLabel: "Scriveteci",
      phoneLabel: "Telefono",
      addressLabel: "Indirizzo",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Valle di Haut-Bréda · Les 7 Laux · Belledonne",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Ristorante · Pizzeria · Bar · Negozio di montagna",
      legal: "Rest'Ô Bréda SARL con capitale sociale di 1 000 € — SIREN 109 246 421 — RCS Grenoble — IVA FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Tutti i diritti riservati.",
    },
  },
  nl: {
    nav: {
      home: "Home",
      story: "Ons verhaal",
      team: "Oprichters",
      establishments: "Vestigingen",
      press: "Pers",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Le Haut-Bréda · Belledonne-massief · Franse Alpen",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["De ziel van de vallei,", "op tafel geserveerd."],
      sub: "Brengt het Haut-Bréda-dal tot leven, zomer en winter.",
      cta2: "Neem contact op",
      scroll: "Scrollen",
    },
    story: {
      eyebrow: "Ons verhaal",
      title: "Een huis geboren aan de oevers van de Bréda",
      p1: "Aan de voet van de Belledonne-toppen, waar de Bréda zijn vallei uitholt tussen sparrenbossen en alpenweiden, wilden vier vennoten veel meer creëren dan een restaurant: een huis dat openstaat voor het hele Haut-Bréda-dal.",
      p2: "In 2026 ingeschreven bij het handelsregister van Grenoble, brengt Rest'Ô Bréda SARL een restaurant, snackbar, pizzeria, bar, brooddepot en bergwinkel samen. Een plek om te leven en elkaar te ontmoeten — voor de valleibewoners én de liefhebbers van Les 7 Laux, in elk seizoen.",
      quote: "„We wilden een eenvoudige, eerlijke plek, waar je de bergen op je bord proeft.“",
      quoteAuthor: "Jean-Philippe Vacher, Zaakvoerder",
      stats: [
        { value: "2026", label: "Oprichtingsjaar" },
        { value: "€ 1.000", label: "Maatschappelijk kapitaal" },
        { value: "4", label: "Oprichters" },
        { value: "1", label: "Werknemer" },
        { value: "38580", label: "Le Haut-Bréda, Isère" },
      ],
    },
    team: {
      eyebrow: "Oprichters",
      title: "Vier gezichten, één huis",
      sub: "Jean-Philippe, Michel, Marie-Hélène en Tetiana — de vier vennoten die Rest'Ô Bréda elke dag dragen.",
      members: [
        { id: "jean-philippe", name: "Jean-Philippe", role: "Zaakvoerder" },
        { id: "michel", name: "Michel", role: "Vennoot" },
        { id: "marie-helene", name: "Marie-Hélène", role: "Vennote" },
        { id: "tetiana", name: "Tetiana", role: "Vennote" },
      ],
    },
    establishments: {
      eyebrow: "Vestigingen",
      line: "Binnenkort een verrassing",
      sub: "Volgt binnenkort",
      date: "Opening uiterlijk op 15 november 2026",
      units: { days: "Dagen", hours: "Uren", minutes: "Minuten", seconds: "Seconden" },
    },
    press: {
      eyebrow: "Pers",
      line: "In opbouw",
      sub: "Deze ruimte is binnenkort beschikbaar.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Kom ons ontmoeten",
      text: "Een vraag, een evenement of zin om het huis te ontdekken? Schrijf ons — we reageren snel.",
      emailLabel: "Schrijf ons",
      phoneLabel: "Telefoon",
      addressLabel: "Adres",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Haut-Bréda-dal · Les 7 Laux · Belledonne",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Restaurant · Pizzeria · Bar · Bergwinkel",
      legal: "Rest'Ô Bréda SARL met een maatschappelijk kapitaal van € 1.000 — SIREN 109 246 421 — RCS Grenoble — BTW FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Alle rechten voorbehouden.",
    },
  },
  ru: {
    nav: {
      home: "Главная",
      story: "Наша история",
      team: "Учредители",
      establishments: "Заведения",
      press: "Пресса",
      contact: "Контакты",
    },
    hero: {
      eyebrow: "Ле-От-Бреда · Массив Белледон · Французские Альпы",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["Душа долины,", "поданная к столу."],
      sub: "Оживляет долину От-Бреда летом и зимой.",
      cta2: "Свяжитесь с нами",
      scroll: "Листайте",
    },
    story: {
      eyebrow: "Наша история",
      title: "Дом, рождённый на берегах Бреда",
      p1: "У подножия вершин Белледонна, там, где река Бреда прорезает свою долину среди еловых лесов и альпийских лугов, четверо партнёров захотели создать нечто большее, чем ресторан: дом, открытый для всей долины От-Бреда.",
      p2: "Зарегистрированная в 2026 году в торговом реестре Гренобля, компания Rest'Ô Bréda SARL объединяет ресторан, снэк-бар, пиццерию, бар, пункт продажи хлеба и горный магазин. Место для жизни и встреч — для жителей долины и для всех, кто любит Ле-Сет-Ло, в любое время года.",
      quote: "«Мы хотели создать простое и честное место, где горы можно попробовать на вкус в тарелке».",
      quoteAuthor: "Жан-Филипп Ваше, директор",
      stats: [
        { value: "2026", label: "Год основания" },
        { value: "1 000 €", label: "Уставный капитал" },
        { value: "4", label: "Учредителя" },
        { value: "1", label: "Сотрудник" },
        { value: "38580", label: "Ле-От-Бреда, Изер" },
      ],
    },
    team: {
      eyebrow: "Учредители",
      title: "Четыре лица, один дом",
      sub: "Жан-Филипп, Мишель, Мари-Элен и Тетяна — четыре партнёра, которые каждый день воплощают Rest'Ô Bréda в жизнь.",
      members: [
        { id: "jean-philippe", name: "Жан-Филипп", role: "Директор" },
        { id: "michel", name: "Мишель", role: "Партнёр" },
        { id: "marie-helene", name: "Мари-Элен", role: "Партнёр" },
        { id: "tetiana", name: "Тетяна", role: "Партнёр" },
      ],
    },
    establishments: {
      eyebrow: "Заведения",
      line: "Скоро вас ждёт сюрприз",
      sub: "Следите за новостями",
      date: "Открытие не позднее 15 ноября 2026 года",
      units: { days: "Дней", hours: "Часов", minutes: "Минут", seconds: "Секунд" },
    },
    press: {
      eyebrow: "Пресса",
      line: "В разработке",
      sub: "Этот раздел скоро будет доступен.",
    },
    contact: {
      eyebrow: "Контакты",
      title: "Приезжайте познакомиться",
      text: "Вопрос, мероприятие или желание узнать нас ближе? Напишите нам — мы быстро ответим.",
      emailLabel: "Напишите нам",
      phoneLabel: "Телефон",
      addressLabel: "Адрес",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Долина От-Бреда · Ле-Сет-Ло · Белледон",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Ресторан · Пиццерия · Бар · Горный магазин",
      legal: "Rest'Ô Bréda SARL с уставным капиталом 1 000 € — SIREN 109 246 421 — RCS Grenoble — НДС FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Все права защищены.",
    },
  },
  uk: {
    nav: {
      home: "Головна",
      story: "Наша історія",
      team: "Засновники",
      establishments: "Заклади",
      press: "Преса",
      contact: "Контакти",
    },
    hero: {
      eyebrow: "Ле-От-Бреда · Масив Белледонн · Французькі Альпи",
      brand: "Rest'Ô Bréda S.A.R.L.",
      lines: ["Душа долини,", "подана до столу."],
      sub: "Оживляє долину От-Бреда влітку та взимку.",
      cta2: "Зв'яжіться з нами",
      scroll: "Гортайте",
    },
    story: {
      eyebrow: "Наша історія",
      title: "Дім, народжений на берегах Бреда",
      p1: "Біля підніжжя вершин Белледонну, там, де річка Бреда прокладає свою долину поміж ялинових лісів та альпійських лук, четверо партнерів захотіли створити щось більше, ніж ресторан: дім, відкритий для всієї долини От-Бреда.",
      p2: "Зареєстрована у 2026 році в торговому реєстрі Гренобля, компанія Rest'Ô Bréda SARL поєднує ресторан, снек-бар, піцерію, бар, пункт продажу хліба та гірський магазин. Місце для життя та зустрічей — для мешканців долини і для тих, хто любить Ле-Сет-Ло, у будь-яку пору року.",
      quote: "«Ми хотіли створити просте та щире місце, де гори можна скуштувати в тарілці».",
      quoteAuthor: "Жан-Філіпп Ваше, директор",
      stats: [
        { value: "2026", label: "Рік заснування" },
        { value: "1 000 €", label: "Статутний капітал" },
        { value: "4", label: "Засновники" },
        { value: "1", label: "Працівник" },
        { value: "38580", label: "Ле-От-Бреда, Ізер" },
      ],
    },
    team: {
      eyebrow: "Засновники",
      title: "Чотири обличчя, один дім",
      sub: "Жан-Філіпп, Мішель, Марі-Елен і Тетяна — четверо партнерів, які щодня наповнюють Rest'Ô Bréda життям.",
      members: [
        { id: "jean-philippe", name: "Жан-Філіпп", role: "Директор" },
        { id: "michel", name: "Мішель", role: "Партнер" },
        { id: "marie-helene", name: "Марі-Елен", role: "Партнерка" },
        { id: "tetiana", name: "Тетяна", role: "Партнерка" },
      ],
    },
    establishments: {
      eyebrow: "Заклади",
      line: "Незабаром на вас чекає сюрприз",
      sub: "Слідкуйте за новинами",
      date: "Відкриття не пізніше 15 листопада 2026 року",
      units: { days: "Днів", hours: "Годин", minutes: "Хвилин", seconds: "Секунд" },
    },
    press: {
      eyebrow: "Преса",
      line: "У розробці",
      sub: "Цей розділ незабаром буде доступний.",
    },
    contact: {
      eyebrow: "Контакти",
      title: "Завітайте до нас",
      text: "Питання, подія чи бажання дізнатися про нас більше? Напишіть нам — ми швидко відповімо.",
      emailLabel: "Напишіть нам",
      phoneLabel: "Телефон",
      addressLabel: "Адреса",
      addressLines: ["1850 Route du Haut-Bréda", "38580 Le Haut-Bréda, France"],
      area: "Долина От-Бреда · Ле-Сет-Ло · Белледонн",
      mapPopup: "Rest'Ô Bréda — Le Haut-Bréda",
    },
    footer: {
      tagline: "Ресторан · Піцерія · Бар · Гірський магазин",
      legal: "Rest'Ô Bréda SARL зі статутним капіталом 1 000 € — SIREN 109 246 421 — RCS Grenoble — ПДВ FR40109246421",
      rights: "© 2026 Rest'Ô Bréda SARL. Усі права захищені.",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rob-lang") || "fr");
  const changeLang = (l) => {
    localStorage.setItem("rob-lang", l);
    setLang(l);
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
